import { logError } from './logError';

type LocalStorageValue =
  | boolean
  | null
  | number
  | string
  | readonly LocalStorageValue[]
  | { readonly [key: string]: LocalStorageValue };

/**
 * Set , get and remove items from local storage
 */
const LocalStorageUtil = {
  set: (key: string, value: LocalStorageValue) => {
    localStorage.setItem(key, JSON.stringify(value));
  },

  get: (key: string): LocalStorageValue | null => {
    const item = localStorage.getItem(key);

    try {
      return item ? JSON.parse(item) : null;
    } catch (error) {
      logError(`Error parsing item from local storage for key ${key}:`, error);
      return null;
    }
  },

  remove: (key: string) => {
    localStorage.removeItem(key);
  },
};

export default LocalStorageUtil;
